<template>
  <div>
    <div class="mt-4">
      <SpecialCareTable :filter-form="filterForm">
      </SpecialCareTable>
    </div>
  </div>
</template>

<script>
import SpecialCareTable from '@/modules/student_care/components/special_care/SpecialCareTable.vue';
import { mapActions } from 'vuex';

export default {
  name: 'SpecialCare',
  components: {
    SpecialCareTable,
  },
  async mounted() {
    const loading = this.$loading.show();
    if (!this.courseExtensionShowField) {
      await this.getCourseExtensionShowField();
    }
    loading.hide();
  },
  methods: {
    ...mapActions('student_care', [
      'getCourseExtensionShowField',
    ]),
  },
  props: {
    filterForm: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
  },
};
</script>

<style scoped>

</style>
